var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      fancy: _vm.fancy,
      label: _vm.label,
      items: _vm.shownItems,
      disabled: _vm.disabled,
      up: _vm.up,
    },
    on: {
      "item-click": function ($event) {
        return _vm.setValue($event)
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            p.item.value
              ? [
                  _vm._v(" " + _vm._s(p.item.value.settingsName)),
                  _c("br"),
                  _vm._v(" " + _vm._s(p.item.value.user) + " "),
                ]
              : [_vm._v(_vm._s(p.item.text))],
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }